var IREP = IREP || {};

IREP.SWIC6 = (function () {
    var defaultOptions = {
        countdownTime: 60,
        useApi: true
    };

    var SWIC6 = function (options) {
        var self = this;

        this.options = $.extend({}, defaultOptions, options);

        this.originalCircle = $('.indicator svg').clone(); // save a copy that hasn't started counting down.

        this.poorMansPreloader();

        try {
            _gaq.push(['_setCustomerVar', 1, 'SWIC2015', 'yes', 1]);
            _gaq.push(['_setCustomerVar', 2, 'SWIC2015', 'yes', 2]);
            _gaq.push(['_trackEvent', 'SWIC2015', 'visit']);
        } catch(e) {}

    };

    SWIC6.getTimestamp = function () {
        if (window.performance && window.performance.now) {
            return window.performance.now();
        } else {
            if (window.performance && window.performance.webkitNow) {
                return window.performance.webkitNow();
            } else {
                return new Date().getTime();
            }
        }
    };

    SWIC6.prototype.delay = function (timeout) {
        var deferred = $.Deferred();

        setTimeout(function () {
            deferred.resolve();
        }, timeout);

        return deferred.promise();
    };

    SWIC6.prototype.track = function(type, label, value, data) {
        IREP.track('SWIC6', type, label, value, data);
        try {
            _gaq.push(['_trackEvent', 'SWIC6', type, label, value]);
        } catch(e) {}
    };

    SWIC6.prototype.trackRecon = function(label, value) {
        this.track('recon', label, value, this.options.mode === 'mobile' ? 1 : 0);
    };

    SWIC6.prototype.trackNavigation = function (label, value) {
        this.track('navigation', label, value, this.options.mode === 'mobile' ? 1 : 0);
    };

    SWIC6.prototype.trackGarage = function (label) {
        this.track('garage', label, null, this.options.mode === 'mobile' ? 1 : 0)
    };

    SWIC6.prototype.trackLeaderboard = function (label) {
        this.track('leaderboards', label, null, this.options.mode === 'mobile' ? 1 : 0)
    };

    SWIC6.prototype.trackStory = function (label) {
        this.track('story', label, null, this.options.mode === 'mobile' ? 1 : 0)
    };

    SWIC6.prototype.animateRings = function () {
        var oldFill = '#58595B';
        var loadFill = '#FFF';
        $('[class^=ring]').css('fill', oldFill);
        var i = 10;
        this.animateRingsIntervalID = setInterval(function () {
            var old = i + 1;
            if (old > 10) {
                old = 0;
            }

            $('.ring' + old).css('fill', oldFill);
            $('.ring' + i).css('fill', loadFill);
            i--;
            if (i < 0) {
                i = 10;
            }
        }, 100);
    };

    SWIC6.prototype.showMoon = function () {
        var self = this;
        var deferred = $.Deferred();

        $('#moon-svg').css('opacity', '1').show();

        self.animateRings();
        this.delay(2000).then(function () {
            deferred.resolve();
        });

        return deferred.promise();
    }

    SWIC6.prototype.hideMoon = function () {
        var self = this;
        var deferred = $.Deferred();

        $('#moon-svg').css('opacity', '0');

        this.delay(2000).then(function () {
            clearInterval(self.animateRingsIntervalID);

            $('#moon-svg').hide();

            deferred.resolve();
        });

        return deferred.promise();
    };

    SWIC6.prototype.switchPage = function (element, klass) {
        var deferred = $.Deferred();

        $('.page').hide();
        $(element).show();

        $('#SWIC6').removeClass();

        if (typeof (klass) !== "undefined") {
            $('#SWIC6').addClass(klass);
        }

        deferred.resolve();
        return deferred.promise();
    };

    SWIC6.prototype.poorMansPreloader = function () {
        var badges = [
            'ambassador.png',
            'einstein.png',
            'expert.png',
            'smart_seller.png',
            'socialite.png',
            'intel_atom.png',
            'intel_atom_x3.png',
            'intel_celeron.png',
            'intel_core.png',
            'intel_core_i3.png',
            'intel_core_i5.png',
            'intel_core_i7.png',
            'intel_core_i7__extreme_edition.png',
            'intel_core_m.png',
            'intel_pentium.png',
            'apprentice.png',
            'legend.png',
            'master.png',
            'novice.png'
        ];

        _.each(badges, function(badge) {
            $('<img />').attr('src', '/content/images/asmo/2015swic/recon/' + badge);
        });
    }


    /*************************
     * RECON
     *************************/

    SWIC6.prototype.startRecon = function () {
        var self = this;

        $('nav [class*=nav]').fadeIn();
        $('#primaryNavBar').fadeIn();
        $('#navigationRight').fadeIn();

        this.switchPage('#recon', 'recon').then(function() {
            $('#recon').children().hide();
            return $.when(self.getReconsAvailable(), self.showMoon());
        }).then(function(recons) {
            self.showReconBoard(recons);
        });
    };

    SWIC6.prototype.getReconsAvailable = function () {
        var deferred = $.Deferred();
        if (this.options.useApi) {
            IREP.callApi({ url: 'swic6/recons' }).then(function (data) {
                deferred.resolve(data.recons);
            });
        } else {
            this.delay(2000).then(function() {
                deferred.resolve([
                    { location: 'slot1', type: 'select2', available: true },
                    { location: 'slot2', type: 'select4', available: true },
                    { location: 'slot3', type: 'truefalse', available: true },
                    { location: 'slot4', type: 'connect2', available: true },
                    { location: 'slot5', type: 'wordreplace', available: true },
                    { location: 'slot6', type: 'connect4', available: true },
                    { location: 'slot7', type: 'multiplechoice', available: true },
                    { location: 'slot8', type: 'wordreplace4', available: true },
                ]);
            });
        }

        return deferred.promise();
    };

    SWIC6.prototype.showReconBoard = function(recons) {
        // Placeholder override in SWIC6Mobile/SWIC6Desktop
    };

    /*************************
     * Recon Instructions
     *************************/

    SWIC6.prototype.startReconInstructions = function (quizType, reconUID) {
        var self = this;

        $('.glowFrame').show();
        this.switchPage('#instructions', quizType).then(function () {
            $('#instructions').off().one('touchstart click', 'svg', function (e) {
                var id = $(this).prop('id');

                if (id === "back-svg") {
                    self.startRecon();
                } else if (id === "begin-svg") {
                    self.startQuiz(quizType, reconUID);
                }

                e.stopPropagation();
                e.preventDefault();
                return false;
            });
        });
    };

    /************************
     * Quiz
     *************************/
    SWIC6.prototype.getQuizTime = function () {
        return Math.round(((SWIC6.getTimestamp() - this.quizStartTime)) / 1000, 0);
    };

    SWIC6.prototype.startQuiz = function (quizType, reconUID) {
        var self = this;

        if (this.options.mode === 'mobile') {
            $('#quiz .indicator').hide();
            $('#quiz .indicator').children().hide();
        } else {
            $('#quiz .indicator').hide();
            $('nav [class*=nav]').fadeOut();
            $('#primaryNavBar').fadeOut();
            $('#navigationRight').fadeOut();
        }

        $('#quiz .question').hide();
        $('#quiz .summary').hide();

        this.switchPage('#quiz', "quiz " + quizType).then(function () {
            return $.when(self.getReconDetail(quizType, reconUID), self.showMoon());
        }).then(function (detail) {
            return $.when(detail, self.hideMoon());
        }).then(function (detail) {
            self.questionNumber = 0;
            self.answers = [];
            self.reconDetail = detail;
            self.quizStartTime = SWIC6.getTimestamp();
            self.answerTime = self.getQuizTime();

            if (self.options.mode === 'mobile') {
                $('#quiz .indicator').show();
                $('#quiz .indicator').children().show();
            } else {
                $('#quiz .indicator').show();
            }

            $('#quiz .question').show();
            $('#quiz .summary').hide();

            $('.indicator div:first-child').empty();

            $.each(detail.questions, function (i, e) {
                $('.indicator div:first-child').append($('<span/>'));
            });

            $('.indicator div:last-child').html(60);
            $('.indicator svg').remove();
            $('.indicator div:last-child').before(self.originalCircle.clone());

            self.displayNextQuizQuestion();

            self.countDown = new IREP.Countdown({ updateTime: 1000, totalTime: self.options.countdownTime * 1000 });
            self.countDown.start().progress(function (timings) {
                $('.indicator circle').css('stroke-dashoffset', self.options.mode === 'mobile' ? '113.10px' : '245.04px');
                $('.indicator div:last-child').html(timings.remaining / 1000);
            }).done(function (timings) {
                self.stopQuiz(timings);
            }).fail(function (timings) {
                self.stopQuiz(timings);
            });

            self.trackRecon('attempt');
        });
    };

    SWIC6.prototype.getReconDetail = function (quizType, reconUID) {
        var self = this;

        var deferred = $.Deferred();

        if (this.options.useApi) {
            IREP.callApi({ url: '/swic6/recon/start', data: { uid: reconUID } }).then(function(data) {
                deferred.resolve(data.recon);
            }).fail(function() {
                self.startRecon();
            });
        } else {
            this.delay(2000).then(function() {
                switch (quizType) {
                case "select2":
                    deferred.resolve(SWIC6.select2);
                    break;
                case "select4":
                    deferred.resolve(SWIC6.select4);
                    break;
                case "truefalse":
                    deferred.resolve(SWIC6.truefalse);
                    break;
                case "wordreplace":
                    deferred.resolve(SWIC6.wordreplace);
                    break;
                case "multiplechoice":
                    deferred.resolve(SWIC6.multiplechoice);
                    break;
                case "connect2":
                    deferred.resolve(SWIC6.connect2);
                    break;
                case "connect4":
                    deferred.resolve(SWIC6.connect4);
                    break;
                case "wordreplace4":
                    deferred.resolve(SWIC6.wordreplace4);
                    break;
                }
            });
        }

        return deferred.promise();
    };

    SWIC6.prototype.increaseQuizIndicator = function () {
        $('#quiz .indicator div:first-child span:not(.completed):first').addClass('completed')
    };

    SWIC6.prototype.displayNextQuizQuestion = function () {
        var self = this;

        var question = this.reconDetail.questions[this.questionNumber];
        var $quiz = $('#quiz');
        $('#submit-svg').hide();
        $('#reset-svg').hide();

        if (question != null) {
            $('#quiz .question h2').html(question.questionText);
            this.increaseQuizIndicator();

            switch (this.reconDetail.type) {
                case "select2":
                    var $select2 = $quiz.find('.select2');
                    $select2.empty();

                    var img0 = $(question.answers[0].answerText);
                    img0.data('answerId', question.answers[0].answerId);
                    img0.data('questionId', question.questionId);
                    $select2.append(img0);
                    
                    $select2.append('<br/>');

                    var img1 = $(question.answers[1].answerText);
                    img1.data('answerId', question.answers[1].answerId);
                    img1.data('questionId', question.questionId);
                    $select2.append(img1);

                    $select2.off().one('click', 'img', function (e) {
                        var answerId = $(this).data('answerId');
                        var questionId = $(this).data('questionId');

                        self.logReconAudit(answerId);

                        self.answers.push({ questionId: questionId, answerId: answerId });

                        self.displayNextQuizQuestion();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });
                    break;
                case "select4":
                    var $select4 = $quiz.find('.select4');
                    $select4.empty();

                    var img0 = $(question.answers[0].answerText);
                    img0.data('answerId', question.answers[0].answerId);
                    img0.data('questionId', question.questionId);
                    $select4.append(img0);

                    var img1 = $(question.answers[1].answerText);
                    img1.data('answerId', question.answers[1].answerId);
                    img1.data('questionId', question.questionId);
                    $select4.append(img1);

                    if (question.answers.length > 2) {
                        $select4.append('<br/>');

                        var img2 = $(question.answers[2].answerText);
                        img2.data('answerId', question.answers[2].answerId);
                        img2.data('questionId', question.questionId);
                        $select4.append(img2);

                        var img3 = $(question.answers[3].answerText);
                        img3.data('answerId', question.answers[3].answerId);
                        img3.data('questionId', question.questionId);
                        $select4.append(img3);
                    }

                    $select4.off().one('click', 'img', function (e) {
                        var answerId = $(this).data('answerId');
                        var questionId = $(this).data('questionId');

                        self.logReconAudit(answerId);

                        self.answers.push({ questionId: questionId, answerId: answerId });

                        self.displayNextQuizQuestion();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });
                    break;
                case "truefalse":
                    var $truefalse = $quiz.find('.truefalse');
                    $truefalse.empty();

                    var truefalse0 = $('<div/>', { html: question.answers[0].answerText, data: { answerId: question.answers[0].answerId, questionId: question.questionId } });
                    $truefalse.append(truefalse0);

                    var truefalse0 = $('<div/>', { html: question.answers[1].answerText, data: { answerId: question.answers[1].answerId, questionId: question.questionId } });
                    $truefalse.append(truefalse0);

                    $truefalse.off().one('click', 'div', function (e) {
                        var answerId = $(this).data('answerId');
                        var questionId = $(this).data('questionId');

                        self.logReconAudit(answerId);

                        self.answers.push({ questionId: questionId, answerId: answerId });
                        self.displayNextQuizQuestion();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });
                    break;
                case "wordreplace":
                    var $wordreplace = $quiz.find('.wordreplace');
                    $wordreplace.empty();

                    var wordreplace0 = $('<div/>', { html: question.answers[0].answerText, data: { answerId: question.answers[0].answerId, questionId: question.questionId } });
                    $wordreplace.append(wordreplace0);

                    var wordreplace1 = $('<div/>', { html: question.answers[1].answerText, data: { answerId: question.answers[1].answerId, questionId: question.questionId } });
                    $wordreplace.append(wordreplace1);

                    var wordreplace2 = $('<div/>', { html: question.answers[2].answerText, data: { answerId: question.answers[2].answerId, questionId: question.questionId } });
                    $wordreplace.append(wordreplace2);

                    var wordreplace3 = $('<div/>', { html: question.answers[3].answerText, data: { answerId: question.answers[3].answerId, questionId: question.questionId } });
                    $wordreplace.append(wordreplace3);

                    $wordreplace.off().one('click', 'div', function (e) {
                        var answerId = $(this).data('answerId');
                        var questionId = $(this).data('questionId');

                        self.logReconAudit(answerId);

                        self.answers.push({ questionId: questionId, answerId: answerId });
                        self.displayNextQuizQuestion();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });

                    break;
                case "multiplechoice":
                    var $multiplechoice = $quiz.find('.multiplechoice');
                    $multiplechoice.empty();

                    var $multiplechoice0 = $('<div/>', { html: question.answers[0].answerText, data: { answerId: question.answers[0].answerId, questionId: question.questionId } });
                    $multiplechoice.append($multiplechoice0);

                    var $multiplechoice1 = $('<div/>', { html: question.answers[1].answerText, data: { answerId: question.answers[1].answerId, questionId: question.questionId } });
                    $multiplechoice.append($multiplechoice1);

                    var $multiplechoice2 = $('<div/>', { html: question.answers[2].answerText, data: { answerId: question.answers[2].answerId, questionId: question.questionId } });
                    $multiplechoice.append($multiplechoice2);

                    var $multiplechoice3 = $('<div/>', { html: question.answers[3].answerText, data: { answerId: question.answers[3].answerId, questionId: question.questionId } });
                    $multiplechoice.append($multiplechoice3);

                    $multiplechoice.off().one('click', 'div', function (e) {
                        var answerId = $(this).data('answerId');
                        var questionId = $(this).data('questionId');

                        self.logReconAudit(answerId);

                        self.answers.push({ questionId: questionId, answerId: answerId });
                        self.displayNextQuizQuestion();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });
                    break;
                case "connect2":
                    var $connect2 = $quiz.find('.connect2');
                    $connect2.empty();

                    var $connect20 = $('<div/>', { html: question.answers[0].answerText, data: { answerId: question.answers[0].answerId, questionId: question.questionId } });
                    $connect2.append($connect20);

                    var $connect21 = $('<div/>', { html: question.answers[1].answerText, data: { answerId: question.answers[1].answerId, questionId: question.questionId } });
                    $connect2.append($connect21);

                    var $connect22 = $('<div/>', { html: question.answers[2].answerText, data: { answerId: question.answers[2].answerId, questionId: question.questionId } });
                    $connect2.append($connect22);

                    var $connect23 = $('<div/>', { html: question.answers[3].answerText, data: { answerId: question.answers[3].answerId, questionId: question.questionId } });
                    $connect2.append($connect23);

                    var connect2count = 0;
                    /*
                    $('#submit-svg').hide();
                    $('#submit-svg').off().one('touchstart click', function (e) {
                        self.displayNextQuizQuestion();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });
                    
                    $('#reset-svg').off().on('touchstart click', function (e) {
                        connect2count = 0;
                        $connect2.find('div').removeClass('first second');
                        $('#submit-svg').hide();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });
                    */

                    $connect2.off().on('click', 'div', function (e) {
                        var answerId = $(this).data('answerId');
                        var questionId = $(this).data('questionId');

                        var $element = $(this);
                        if ($element.hasClass('first') || $element.hasClass('second')) {
                            return;
                        }

                        if (connect2count === 0 || connect2count === 1) {
                            $(this).addClass('first');
                        } else if (connect2count === 2 || connect2count === 3) {
                            $(this).addClass('second');
                        }
                        /*
                        if (connect2count === 3) {
                            $('#submit-svg').show();
                        }
                        */
                        
                        ++connect2count;

                        self.logReconAudit(answerId);

                        self.answers.push({ questionId: questionId, answerId: answerId });

                        if (connect2count >= 2) {
                            self.displayNextQuizQuestion();
                        }

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });

                    break;
                case "connect4":
                    var $connect4 = $quiz.find('.connect4');
                    $connect4.empty();

                    var $connect40 = $('<div/>', { html: question.answers[0].answerText, data: { answerId: question.answers[0].answerId, questionId: question.questionId } });
                    $connect4.append($connect40);

                    var $connect41 = $('<div/>', { html: question.answers[1].answerText, data: { answerId: question.answers[1].answerId, questionId: question.questionId } });
                    $connect4.append($connect41);

                    var $connect42 = $('<div/>', { html: question.answers[2].answerText, data: { answerId: question.answers[2].answerId, questionId: question.questionId } });
                    $connect4.append($connect42);

                    var $connect43 = $('<div/>', { html: question.answers[3].answerText, data: { answerId: question.answers[3].answerId, questionId: question.questionId } });
                    $connect4.append($connect43);

                    var $connect44 = $('<div/>', { html: question.answers[4].answerText, data: { answerId: question.answers[4].answerId, questionId: question.questionId } });
                    $connect4.append($connect44);

                    var $connect45 = $('<div/>', { html: question.answers[5].answerText, data: { answerId: question.answers[5].answerId, questionId: question.questionId } });
                    $connect4.append($connect45);

                    var $connect46 = $('<div/>', { html: question.answers[6].answerText, data: { answerId: question.answers[6].answerId, questionId: question.questionId } });
                    $connect4.append($connect46);

                    var $connect47 = $('<div/>', { html: question.answers[7].answerText, data: { answerId: question.answers[7].answerId, questionId: question.questionId } });
                    $connect4.append($connect47);

                    var connect4count = 0;
                    $('#submit-svg').hide();
                    $('#submit-svg').off().one('click', function (e) {
                        self.displayNextQuizQuestion();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });

                    $('#reset-svg').off().on('click', function (e) {
                        connect4count = 0;
                        $connect4.find('div').removeClass('first second third fourth');
                        $('#submit-svg').hide();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });

                    $connect4.off().on('click', 'div', function (e) {
                        var $element = $(this);
                        if ($element.hasClass('first') || $element.hasClass('second') || $element.hasClass('third') || $element.hasClass('fourth')) {
                            return;
                        }

                        if (connect4count === 0 || connect4count === 1) {
                            $(this).addClass('first');
                        } else if (connect4count === 2 || connect4count === 3) {
                            $(this).addClass('second');
                        } else if (connect4count === 4 || connect4count === 5) {
                            $(this).addClass('third');
                        } else if (connect4count === 6 || connect4count === 7) {
                            $(this).addClass('fourth');
                        }

                        if (connect4count === 7) {
                            $('#submit-svg').show();
                        }

                        ++connect4count;

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });

                    break;
                case "wordreplace4":
                    $('#reset-svg').show();
                    $('#submit-svg').show();

                    var $wordreplace4 = $quiz.find('.wordreplace4');
                    $wordreplace4.empty();

                    var $wordreplace40 = $('<div/>', { html: question.answers[0].answerText, data: { answerId: question.answers[0].answerId, questionId: question.questionId } });
                    $wordreplace4.append($wordreplace40);

                    var $wordreplace41 = $('<div/>', { html: question.answers[1].answerText, data: { answerId: question.answers[1].answerId, questionId: question.questionId } });
                    $wordreplace4.append($wordreplace41);

                    var $wordreplace42 = $('<div/>', { html: question.answers[2].answerText, data: { answerId: question.answers[2].answerId, questionId: question.questionId } });
                    $wordreplace4.append($wordreplace42);

                    var $wordreplace43 = $('<div/>', { html: question.answers[3].answerText, data: { answerId: question.answers[3].answerId, questionId: question.questionId } });
                    $wordreplace4.append($wordreplace43);

                    var wordreplace4count = 0;
                    
                    $('#submit-svg').off().one('click', function (e) {
                        self.displayNextQuizQuestion();

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });

                    $('#reset-svg').off().on('click', function (e) {
                        wordreplace4count = 0;
                        $wordreplace4.find('div').removeClass('first second third fourth');

                        self.logReconAudit(0);
                        self.answers = [];

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });

                    $wordreplace4.off().on('click', 'div', function (e) {
                        var answerId = $(this).data('answerId');
                        var questionId = $(this).data('questionId');

                        var $element = $(this);
                        if ($element.hasClass('first') || $element.hasClass('second') || $element.hasClass('third') || $element.hasClass('fourth')) {
                            return;
                        }

                        if (wordreplace4count === 0) {
                            $(this).addClass('first');
                        } else if (wordreplace4count === 1) {
                            $(this).addClass('second');
                        } else if (wordreplace4count === 2) {
                            $(this).addClass('third');
                        } else if (wordreplace4count === 3) {
                            $(this).addClass('fourth');
                        }

                        ++wordreplace4count;

                        self.logReconAudit(answerId);
                        self.answers.push({ questionId: questionId, answerId: answerId, sequenceNo: wordreplace4count });

                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });

                    break;
            }

            ++this.questionNumber;
        } else {
            this.countDown.stop();
        }
    };

    SWIC6.prototype.logReconAudit = function (answerId) {
        var currentTime = this.getQuizTime();
        var answerTime = currentTime - this.answerTime;
        this.answerTime = currentTime;

        var data = { "auditUID": this.reconDetail.auditUID, "answerId": answerId, "answerTime": answerTime };
        return IREP.callApi({ url: '/swic6/recon/audit', type: 'POST', data: data });
    };

    SWIC6.prototype.stopQuiz = function (timings) {
        var self = this;

        this.countDown = null;

        var unanswered = _.filter(this.reconDetail.questions, function (e, i) {
            return !_.any(self.answers, function (answer) { return answer.questionId == e.questionId })
        });

        $.each(unanswered, function (i, e) {
            self.answers.push({ questionId: e.questionId, answerId: 0 });
        });

        this.startQuizSummary(timings);
    };

    /***************************
     * Quiz Summary
     *****************************/

    SWIC6.prototype.startQuizSummary = function (timings) {
        var self = this;

        $('#quiz .question').hide();
        if (this.options.mode === 'mobile') {
            $('#quiz .indicator').hide();
            $('#quiz .indicator').children().hide();
        } else {
            $('#quiz .indicator').hide();
        }

        $.when(self.postReconResult(timings.elapsed / 1000), this.showMoon()).then(function(result) {
            return $.when(result, self.hideMoon());
        }).then(function(result) {
            if (self.options.mode === 'mobile') {
                $('#quiz .indicator').show();
            } else {
                $('nav [class*=nav]').fadeIn();
                $('#primaryNavBar').fadeIn();
                $('#navigationRight').fadeIn();
            }

            $('#quiz .summary .total').html(result.total);
            $('#quiz .summary .completed').html(result.completed);
            $('#quiz .summary .correct').html(result.correct);
            $('#quiz .summary .timeTaken').html(result.timeTaken);
            $('#quiz .summary').show();
            
            self.trackRecon('completion');

            if (result.correct / result.total >= 0.8) {
                self.trackRecon('pass');
            } else {
                self.trackRecon('fail');
            }
        });


        $('#quiz .summary #recon-button-svg').one('touchstart click', function (e) {
            self.startRecon();

            e.stopPropagation();
            e.preventDefault();
            return false;
        });
    };

    SWIC6.prototype.postReconResult = function (time) {
        var self = this;
        var deferred = $.Deferred();

        if (this.options.useApi) {
            var data = {
                uid: this.reconDetail.uid,
                activityUID: this.reconDetail.activityUID,
                auditUID: this.reconDetail.auditUID,
                time: time,
                results: this.answers
            };

            var headers = {};
            if (self.options.mode === 'mobile') {
                headers.Mobile = "2.1";
            }

            IREP.callApi({ type: 'POST', url: '/swic6/recon/result', headers: headers, data: data }).done(function(data) {
                deferred.resolve(data);
            });
        } else {
            deferred.resolve({
                completed: 5,
                correct: 5,
                total: 5,
                timeTaken: 30
            });
        }

        return deferred.promise();
    }

    /************************
     * END
     *************************/

    SWIC6.select2 = {
        type: 'select2',
        questions: [{
            questionText: 'Which processor has the fastest speed?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 2,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }, {
            questionText: 'Which processor has the slowest speed?',
            questionId: 2,
            answers: [{
                answerId: 3,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 4,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }, {
            questionText: 'Which processor has the fastest speed?',
            questionId: 3,
            answers: [{
                answerId: 5,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 6,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }, {
            questionText: 'Which processor has the slowest speed?',
            questionId: 4,
            answers: [{
                answerId: 7,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 8,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }, {
            questionText: 'Which processor has the fastest speed?',
            questionId: 5,
            answers: [{
                answerId: 9,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 10,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }]
    };

    SWIC6.select4 = {
        type: 'select4',
        questions: [{
            questionText: 'Which processor has the fastest speed?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 2,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 11,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 12,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }, {
            questionText: 'Which processor has the slowest speed?',
            questionId: 2,
            answers: [{
                answerId: 3,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 4,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 13,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 14,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }, {
            questionText: 'Which processor has the fastest speed?',
            questionId: 3,
            answers: [{
                answerId: 5,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 6,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 15,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 16,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }, {
            questionText: 'Which processor has the slowest speed?',
            questionId: 4,
            answers: [{
                answerId: 7,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 8,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 17,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 18,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }, {
            questionText: 'Which processor has the fastest speed?',
            questionId: 5,
            answers: [{
                answerId: 9,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-atom.svg" />'
            }, {
                answerId: 10,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 19,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }, {
                answerId: 20,
                answerText: '<img src="/content/images/asmo/2015swic/mobile/processor-corei7.svg" />'
            }]
        }]
    };

    SWIC6.truefalse = {
        type: 'truefalse',
        questions: [{
            questionText: 'Is this a question with long enough text to fill 4 lines?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'True'
            }, {
                answerId: 2,
                answerText: 'False'
            }]
        }, {
            questionText: 'Is this a question with long enough text to fill 2 lines?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'True'
            }, {
                answerId: 2,
                answerText: 'False'
            }]
        }, {
            questionText: 'Is this a question with long enough text to fill 3 lines?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'True'
            }, {
                answerId: 2,
                answerText: 'False'
            }]
        }, {
            questionText: 'Is this a question with long enough text to fill 2 lines?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'True'
            }, {
                answerId: 2,
                answerText: 'False'
            }]
        }, {
            questionText: 'Is this a question with long enough text to fill 3 lines?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'True'
            }, {
                answerId: 2,
                answerText: 'False'
            }]
        }]
    };

    SWIC6.wordreplace = {
        type: 'wordreplace',
        questions: [{
            questionText: '_________________ processors are installed on desktop computers.',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }, {
            questionText: '_________________ processors are installed on mobile computers.',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }, {
            questionText: '_________________ processors are installed on desktop computers.',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }, {
            questionText: '_________________ processors are installed on mobile computers.',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }, {
            questionText: '_________________ processors are installed on desktop computers.',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }]
    }

    SWIC6.multiplechoice = {
        type: 'multiplechoice',
        questions: [{
            questionText: 'Which has the fastest speed?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }, {
            questionText: 'Which has the slowest speed?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }, {
            questionText: 'Which has the fastest speed?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }, {
            questionText: 'Which has the slowest speed?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }, {
            questionText: 'Which has the fastest speed?',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        }]
    }

    SWIC6.connect2 = {
        type: 'connect2',
        questions: [{
            questionText: 'Match Processor with the Correct Attribute',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Description<br/> Type A'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i3'
            }, {
                answerId: 1,
                answerText: 'Description<br/> Type B'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i5'
            }]
        }, {
            questionText: 'Match Processor with the Correct Attribute',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Description<br/> Type A'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i3'
            }, {
                answerId: 1,
                answerText: 'Description<br/> Type B'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i5'
            }]
        }, {
            questionText: 'Match Processor with the Correct Attribute',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Description<br/> Type A'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i3'
            }, {
                answerId: 1,
                answerText: 'Description<br/> Type B'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i5'
            }]
        }, {
            questionText: 'Match Processor with the Correct Attribute',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Description<br/> Type A'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i3'
            }, {
                answerId: 1,
                answerText: 'Description<br/> Type B'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i5'
            }]
        }, {
            questionText: 'Match Processor with the Correct Attribute',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Description<br/> Type A'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i3'
            }, {
                answerId: 1,
                answerText: 'Description<br/> Type B'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i5'
            }]
        }]
    }

    SWIC6.connect4 = {
        type: 'connect4',
        questions: [{
            questionText: 'Match Processor with the Correct Attribute',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Description<br/> Type A'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i3'
            }, {
                answerId: 1,
                answerText: 'Description<br/> Type B'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i5'
            }, {
                answerId: 1,
                answerText: 'Description<br/> Type C'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i5 vPro'
            }, {
                answerId: 1,
                answerText: 'Description<br/> Type D'
            }, {
                answerId: 2,
                answerText: 'Intel<br/> Core i7'
            }]
        }]
    }

    SWIC6.wordreplace4 = {
        type: 'wordreplace4',
        questions: [{
            questionText: 'Lorem ipsum _______ dolor sit amet, consectetur ______ adipiscing elit. Sed do ____ eiusmod tempor _______ incididunt ut.',
            questionId: 1,
            answers: [{
                answerId: 1,
                answerText: 'Intel Celeron'
            }, {
                answerId: 2,
                answerText: 'Intel Core i3'
            }, {
                answerId: 3,
                answerText: 'Intel Core i5'
            }, {
                answerId: 4,
                answerText: 'Intel Core i7'
            }]
        },]
    }


    return SWIC6;
}());
